import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/classroomInteraction/common/tick.png'


_pushScopeId("data-v-0d61f582")
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_2 = {
  class: "select-image",
  src: _imports_0
}
const _hoisted_3 = { class: "gc-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "gc-name" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
_popScopeId()

import type { CSSProperties, PropType } from "vue";
import { ref } from "vue";

type cardInfo = {
  avatar: string;
  groupName: string;
  groupNumber: number;
  addPoint?: number;
  dockPoint?: number;
};


export default _defineComponent({
  props: {
  cardStyleInfo: {
    type: Object as PropType<CSSProperties>,
    default: undefined,
  },
  cardInfo: {
    type: Object as PropType<cardInfo>,
    default: () => ({
      avatar: "",
      group: 0,
      groupNumber: 0,
    }),
  },
  isSelected: {
    type: Boolean,
    default: () => false,
  },
},
  setup(__props) {

const props = __props


// 兼容本地图片地址的url和网络地址的url
const getUrlInfo = (url: string): any => {
  const reg = /http[s]{0,1}:/gi;
  // 网络地址，直接用
  if (reg.test(url)) {
    return url;
  }
  const img = require("@/assets/img/classroomInteraction/groupAvatar/" + url);
  return img;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gc-container",
      style: _normalizeStyle(__props.cardStyleInfo ? __props.cardStyleInfo : {})
    }, [
      _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
        [_vShow, __props.isSelected]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: getUrlInfo(__props.cardInfo.avatar),
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.cardInfo.groupName) + " " + _toDisplayString(__props.cardInfo.groupNumber) + "人 ", 1),
      _renderSlot(_ctx.$slots, "point")
    ], 4),
    _hoisted_6
  ]))
}
}

})